import { render, staticRenderFns } from "./ReferDetailWindow.vue?vue&type=template&id=96ef532a&"
import script from "./ReferDetailWindow.vue?vue&type=script&lang=js&"
export * from "./ReferDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./ReferDetailWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferDetailWindow.vue"
export default component.exports